<modal-container #modal [headerTitle]="isReauth ? 'user.relogin-title' : 'user.add-account'" [isSmallModal]="true">
  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      @if (isReauth) {
        <div class="reauth-hint mb-3" data-cy="reauth-hint">
          {{ 'user.session-expired' | translate }}
        </div>
      }
      @if (hasError) {
        <div class="alert alert-danger mb-3">
          {{ 'login.error.msg' | translate }}
        </div>
      }
      @if (isFormRendered) {
        <form [formGroup]="form" (keydown.enter)="$event.preventDefault(); addAccount()">
          <form-row-input
            [label]="'login.username'"
            [inputType]="'email'"
            [formGroup]="form"
            formControlName="email"
            [required]="submitted && formControls.email.errors?.required"
            [requiredCssClass]="submitted && formControls.email.errors"
            [elementName]="'add-login-email'"
            [autocomplete]="'username'"
            [dataCyAttribute]="'add-login-email'"
            [isLoginInput]="true"
            [inputDisabled]="isReauth"
            [autofillReadonly]="true"
          ></form-row-input>
          <form-row-input
            [label]="'login.password'"
            [formGroup]="form"
            formControlName="password"
            [autocomplete]="'current-password'"
            [required]="submitted && formControls.password.errors?.required"
            [requiredCssClass]="submitted && formControls.password.errors"
            [elementName]="'add-login-password'"
            [inputType]="showPassword ? 'text' : 'password'"
            [appendBtnIcon]="showPassword ? 'far-eye-slash' : 'far-eye'"
            [appendBtnClasses]="['btn-input']"
            (onAppendBtnEvent)="toggleShowPassword()"
            [dataCyAttribute]="'add-login-password'"
            [autofillReadonly]="true"
          ></form-row-input>
          <form-row-select
            [label]="'login.server'"
            [model]="form.get('clientType').value"
            (modelChange)="form.get('clientType').setValue($event)"
            [options]="clientTypeOptions"
            [dataCyAttribute]="'add-login-server'"
            [isSelectDisabled]="isReauth"
          ></form-row-select>
          @if (form.get('clientType').value === 'custom') {
            <form-row-input
              [label]="'login.server'"
              [formGroup]="form"
              formControlName="customUrl"
              [elementName]="'add-login-custom-url'"
              [dataCyAttribute]="'add-login-custom-url'"
              [inputDisabled]="isReauth"
            ></form-row-input>
          }
        </form>
      }
    </div>
  </ng-container>
  <ng-container class="modal-footer-content">
    <btn
      [label]="'login.loginbtn'"
      [title]="'login.loginbtn' | translate"
      [icon]="'far-sign-in'"
      [classes]="['btn-first']"
      [isLoading]="loading"
      (onEvent)="addAccount()"
      [dataCyAttribute]="'add-login-submit'"
    ></btn>
  </ng-container>
</modal-container>
